import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

function OrderFormShippingRates(props) {
  return (
    <React.Fragment>

      <Grid item sm={12}>
        <Typography variant="overline">Shipping Method & Rates</Typography>
        <div style={{ borderBottom: '1px dashed black' }}></div>
      </Grid>

      <Grid item sm={12} style={{ textAlign: 'right' }}>
        {props.isRecordSaved ?
          <React.Fragment>
            <Button size="small" color="secondary" onClick={props.easyPostCreateShipment}>{props.shipmentId !== '' ? 'Re-Create Shipment' : 'Get Rates'}</Button>
            {(props.shipmentId !== '' && '' === props.labelUrl) &&
              <Button variant="contained" size="small" color="error" disabled={'' === props.rateId}
                onClick={props.easyPostConfirmRateBuildLabel} style={{ marginLeft: 12 }}>Confirm Rate to Build Label</Button>
            }
            {props.labelUrl !== '' &&
              <a href={props.labelUrl} target="_blank"><Button variant="contained" size="small" color="success" style={{ marginLeft: 12 }}>View Label</Button></a>
            }
          </React.Fragment>
          :
          <Alert variant="filled" severity="warning">You must save changes to database before you can perform any action via EasyPost.</Alert>
        }
      </Grid>
      <Grid item sm={12}>
        {(props.rates && props.rates.length > 0) &&
          <FormControl fullWidth>
            <FormLabel>Select a Shipping Method & Rate</FormLabel>
            <RadioGroup
              value={props.rateId} onChange={(evt) => props.onChange(props.shipmentId, evt.target.value, true)}
              style={{ maxHeight: 280, overflow: 'auto' }}
            >
              {props.rates.map((rate, dex) =>
                <FormControlLabel key={'rate-' + dex} control={<Radio />}
                  value={rate.id} label={rate.carrier + ' - ' + rate.service + ' -- $' + rate.rate}
                />
              )}
            </RadioGroup>
          </FormControl>
        }
      </Grid>

    </React.Fragment>
  );
}

export default OrderFormShippingRates;
